import React from 'react';
import { withRouter } from 'react-router-dom';

import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

import { withStyles } from '@material-ui/core/styles';

import CoatofArms from '../../../Resources/Coat_of_arms_of_Malaysia.png';
import JPSLogo from '../../../Resources/Logo.PNG';

const styles = theme => ({
    toolbar: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        height: '100%',
    },
    toolbarSecondary: {
        justifyContent: 'flex-start',
        overflowX: 'auto',
    },
    link: {
        padding: theme.spacing(1),
        flexShrink: 0,
        fontWeight: 'bold'
    },
    linkButton: {
        padding: theme.spacing(1),
        flexShrink: 0,
        fontWeight: 'bold',
        textAlign: 'center',
        width: '150px'
    }
})

class NavComponent extends React.Component {

    goLogin = () => {
        this.props.history.push({
            pathname: '/Login'
        })
    }

    goHome = () => {
        this.props.history.push({
            pathname: '/'
        })
    }

    goListing = () => {
        this.props.history.push({
            pathname: '/Listing'
        })
    }

    goDataview = () => {
        this.props.history.push({
            pathname: '/Dataview'
        })
    }

    render() {
        const { classes } = this.props
        return (
            <React.Fragment>
                <Toolbar className={classes.toolbar}>
                    <Grid container>
                        <Grid item xs={12} sm={11} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Hidden xsDown>
                                <img src={CoatofArms} alt="logo" style={{ height: '8vh', objectFit: 'contain', padding: '0px 15px 0px 15px' }} />
                                <img src={JPSLogo} alt="logo" style={{ height: '8vh', objectFit: 'contain', padding: '0px 15px 0px 15px' }} />
                            </Hidden>
                            <Typography style={{ fontWeight: 'bold', padding: '10px 0px 10px 0px' }}>TELEMETRY WEBPORTAL
                                <br /> DEPARTMENT OF IRRIGATION AND DRAINAGE
                                <br /> WILAYAH PERSEKUTUAN KUALA LUMPUR</Typography>
                        </Grid>

                        <Grid item xs={12} sm={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                            <Button variant="outlined" size="small" onClick={this.goLogin}>
                                Login
                            </Button>
                        </Grid>
                    </Grid>

                </Toolbar>

                <Toolbar component="nav" variant="dense" className={classes.toolbarSecondary}>
                    <Button className={classes.linkButton}
                        color="inherit" component={Link}
                        onClick={this.goHome}>
                        Home
                    </Button>
                    <Button className={classes.linkButton}
                        color="inherit" component={Link}
                        onClick={this.goListing}>
                        Listing
                    </Button>
                    <Button className={classes.linkButton}
                        color="inherit" component={Link}
                        onClick={this.goDataview}>
                        Data View
                    </Button>
                </Toolbar>
            </React.Fragment >
        )
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(NavComponent));